import { render, staticRenderFns } from "./BannerBig.vue?vue&type=template&id=6c532d24&"
import script from "./BannerBig.vue?vue&type=script&lang=js&"
export * from "./BannerBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports